var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('v-img',{staticClass:"logo",attrs:{"lazy-src":require('@/assets/img/hirefly-logo-1.png'),"height":_vm.width,"width":_vm.height,"contain":"","src":require('@/assets/img/hirefly-logo-1.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }